import { SimuladorConsumosDet } from './../entities/simuladorConsumoDet.entity';
import { UsuarioUpdate } from './../entities/usuarioUpdate.entity';
import { PrimerAcceso } from './../entities/primerAcceso.entity';
import { ContratosUser } from './../entities/ContratosUser.entity';
import { ResetPassword } from './../entities/resetPassword.entity';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Headers, RequestOptions } from '@angular/http';
import { HttpService } from './http.service';
import { SessionService } from './session.service';
import { RegisterUser } from '../entities/RegisterUser.entity';
import { Explotacion } from '../entities/explotacion.entity';
import { Login } from '../entities/login.entity';
import { UsuarioOnline } from '../entities/UsuarioOnline.entity';
import { Factura } from '../entities/factura.entity';
import { FacturaSeleccion } from '../entities/facturaSeleccion.entity';
import { Contacto } from '../entities/contacto.entity';
import { Domiciliacion } from '../entities/domiciliacion.entity';
import { SimuladorConsumos } from '../entities/simuladorConsumos.entity';
import { FacturasFiltro } from '../entities/facturasFiltro';


@Injectable()
export class UserService {

    constructor(private httpService: HttpService, private sessionService: SessionService) { }

    public registerUser(explotacion: string, user: RegisterUser): Observable<any> {
        return this.httpService.httpPut(user, this.sessionService.apiServer +  'UsuariosOnline/Registro?explotacionCodigo=' + explotacion);
    }

    public login(explotacion: string, user: Login ): Observable<any> {
        return this.httpService.httpPost(user, this.sessionService.apiServer +  'UsuariosOnline/Login?explotacionCodigo='  + explotacion);
    }

    public authenticate(user: ContratosUser): Observable<any> {
        return this.httpService.httpPostWithNoBlock(user, this.sessionService.apiServer + 'users/Authenticate');
    }

    public getContratos(contratoCodigo?: number): Observable<any> {
        const query = contratoCodigo ? '?contratoCodigo=' + contratoCodigo : '';
        return this.httpService.httpGetAuthorizated(this.sessionService.apiServer + 'UsuariosOnline/Contratos' + query, true);
    }

    public resetPassword(user: ResetPassword): Observable<any> {
        return this.httpService.httpPost(user, this.sessionService.apiServer +
            'UsuariosOnline/ResetearPassword?explotacionCodigo=' + user.Poblacion);
    }

    public FirstAccess(explotacion: string, user: PrimerAcceso): Observable<any> {
        return this.httpService.httpPut(user, this.sessionService.apiServer +
            'UsuariosOnline/PrimerAcceso?explotacionCodigo=' + explotacion);
    }

    public getExplotaciones(): Observable<any> {
        return this.httpService.httpGet(this.sessionService.apiServer +  'GetExplotacionesViewModel');
    }

    public getSimuladorConsumos(explotacion: string, contrato: number) {
        return this.httpService.httpGetAuthorizated(this.sessionService.apiServer
            +  'TextosSimulacion?explotacionCodigo=' + explotacion + '&codContrato=' + contrato);
    }

    public generarSimulacion(explotacion: string, datos: SimuladorConsumos): Observable<any> {
        return this.httpService.httpPut(datos, this.sessionService.apiServer +
            'GeneraSimulacion?explotacionCodigo=' + explotacion);
    }

    public generarSimulacionDetallado(explotacion: string, datos: SimuladorConsumosDet): Observable<any> {
        return this.httpService.httpPut(datos, this.sessionService.apiServer +
            'GeneraSimulacionDetallado?explotacionCodigo=' + explotacion);
    }

    public descargarSimulacion(explotacion: string, datos: SimuladorConsumos): Observable<any> {
        return this.httpService.putDownloadFile(datos, this.sessionService.apiServer +
            'DescargaSimulacion?explotacionCodigo=' + explotacion);
    }

    public contacto(explotacion: string, contacto: Contacto): Observable<any> {
        return this.httpService.httpPut(contacto, this.sessionService.apiServer +
            'UsuariosOnline/Contacto?explotacionCodigo=' + explotacion);
    }
    public contactoPublico(explotacion: string, contacto: Contacto): Observable<any> {
        return this.httpService.httpPut(contacto, this.sessionService.apiServer +
            'UsuariosOnline/ContactoPublico?explotacionCodigo=' + explotacion);
    }
    public descargaFactura(factura: FacturaSeleccion): Observable<any> {
        return this.httpService.putDownloadFile(factura, this.sessionService.apiServer + 'DownloadPdfFile');
    }

    public domiciliarFactura(explotacion: string, datos: Domiciliacion): Observable<any> {
        return this.httpService.httpPut(datos, this.sessionService.apiServer +
            'Domiciliacion?explotacionCodigo=' + explotacion);
    }

    public descargarMandato(explotacion: string, datos: Domiciliacion): Observable<any> {
        return this.httpService.putDownloadFile(datos, this.sessionService.apiServer +
            'Mandato?explotacionCodigo=' + explotacion);
    }

    public correspondenciaFactura(explotacion: string, datos: Domiciliacion): Observable<any> {
        return this.httpService.httpPut(datos, this.sessionService.apiServer +
            'Correspondencia?explotacionCodigo=' + explotacion);
    }

    public upload(explotacion: string, files) {
        return this.httpService.httpPostlectura(files, this.sessionService.apiServer + 'AutoLectura?explotacionCodigo='
            + explotacion);
    }

    public getImages() {
        return this.httpService.httpGet(this.sessionService.apiServer + 'getimages');
        }

    public updateuser(explotacion: string, user: UsuarioUpdate): Observable<any> {
        return this.httpService.httpPut(user, this.sessionService.apiServer +
            'DatosUsuario?explotacionCodigo=' + explotacion);
    }

    public ObtenerFacturas(explotacion: string, facturas: FacturasFiltro): Observable<any> {
        return this.httpService.httpPost(facturas, this.sessionService.apiServer +
            'getFacturas?explotacionCodigo=' + explotacion);
    }

    public uploadSolicitud(explotacion: string, files) {
        return this.httpService.httpPostlectura(files, this.sessionService.apiServer + 'DocumentoSolicitud?explotacionCodigo='
            + explotacion);
    }
    
        /**
     * Obtiene la lista de códigos de teléfono por país.
     * @param {string} explotacion - Código de explotación.
     * @returns {Observable<any>} - Un observable que contiene la lista de naciones para la explotación especificada.
     */
        public getNaciones(explotacion: string) {
            return this.httpService.httpGet(this.sessionService.apiServer + 'GetNaciones?explotacionCodigo=' + explotacion);
        }
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/services/user.service.ts